import React, { useMemo } from "react"
import TableContainer from "components/Common/TableContainer"
import { Link } from "react-router-dom"
import avatar from "../../../assets/images/avatar.png"
import edit from "../../../assets/images/icons/edit.svg"
import { UncontrolledTooltip } from "reactstrap"
import { getAdminsStatus, getTableSortingHeaderIcon } from "helpers/common"
import { usePermission } from "hooks/usePermission"
import DefaultAvatar from "components/CommonForBoth/TopbarDropdown/DefaultAvatar"

const UserSearchResults = ({ data = [], close }) => {
  const { hasAnyPermission, hasPermission } = usePermission()

  const columns = useMemo(() => {
    const data = [
      {
        header: ({ column }) =>
          getTableSortingHeaderIcon(column, " User Details"),
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: ({ row }) => (
          <DefaultAvatar
            email={row?.original.email}
            name={row?.original.name}
          />
        ),
      },
      {
        header: () => <div className="flex items-center gap-2">Date</div>,
        accessorKey: "formatted_created_at",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }) => (
          <div className="code-status">
            {getAdminsStatus(row?.original.status)}
          </div>
        ),
      },

      {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => {
          const editTooltip = `editTooltip-${row?.original.id}`

          return (
            <div className="d-flex justify-content-center align-items-center gap-3">
              {hasPermission("USERS_UPDATE") && (
                <>
                  <div className="action-view">
                    <Link
                      to={`/manage-users/edit/${row?.original.id}`}
                      onClick={close}
                    >
                      <img src={edit} id={editTooltip} alt="" />
                      <UncontrolledTooltip placement="top" target={editTooltip}>
                        Edit
                      </UncontrolledTooltip>
                    </Link>
                  </div>
                </>
              )}
            </div>
          )
        },
      },
    ]

    const canAccess = hasAnyPermission(["USERS_UPDATE", "USERS_DELETE"])
    if (canAccess) return data
    return data.filter((item) => item.id !== "actions")
  }, [hasAnyPermission])

  return (
    <>
      <TableContainer
        filters={{ page: 1, pageSize: 100 }}
        columns={columns}
        data={data}
        count={data.length}
        isPagination={false}
        isCustomPageSize={false}
        pagination="pagination"
        paginationWrapper="dataTables_paginate paging_simple_numbers"
        tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
      />
    </>
  )
}

export default UserSearchResults
